export default __webpack_public_path__ + "static/media/banner.4301f70f.png";